import MainLayout from '@/components/Layout/Layout';
import ReactGA from "react-ga4";
import { Outlet, Route, Routes } from 'react-router-dom';
import MarketPage from "./market_page";
import HomePage from './pages/home';
import PolicyPage from './pages/policy';
import TermsPage from './pages/terms';
import CampaignPage from './pages/campaign';
import CampaignDetail from './pages/campaign-detail';
import ChartLite from './chartlite_page';
import "./index.css"

function NotFoundComponent() {
  if (window.holdstation?.PageNotFound) {
    return <window.holdstation.PageNotFound />;
  }

  return <div>Page Not Found</div>;
}

ReactGA.initialize("G-CNE7977PYY");

export default function Application() {
  return (
    <Routes>
      <Route
        element={
          <MainLayout>
            <Outlet />
          </MainLayout>
        }
        path='/'
      >
        <Route path="/campaign/:id" element={<CampaignDetail />} />
        <Route path="/campaign" element={<CampaignPage />} />
        <Route path="/policy" element={<PolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route index element={<HomePage />} />
      </Route>
      <Route path="/market" element={<MarketPage />} />
      <Route path="/chartlite" element={<ChartLite />} />


      <Route path="*" element={<NotFoundComponent />} />
    </Routes>
  );
}

